// extracted by mini-css-extract-plugin
export default {"logo":"topMenu_logo__0FAZB","text":"topMenu_text__yhsib","container":"topMenu_container__PvEZ4","mobile_menu_container":"topMenu_mobile_menu_container__evsZt"};